<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-8 flex flex-col h-full w-full py-8">

                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col min-ht-78">
                    <div class="h-full flex justify-start items-center">
                        <div v-if="token" class="flex-shrink-0 mr-4">
                            <icon-back @click.stop="goBackTo('/post-training')"></icon-back>
                        </div>
                        <div class="flex-grow">
                            <div class="flex items-center text-sm font-light">
                                <router-link to="/dashboard"
                                    class="opacity-50 hover:opacity-100">Dashboard</router-link>
                                <span class="mx-2">/</span>
                                <router-link to="/training-module"
                                    class="opacity-50 hover:opacity-100">Internship</router-link>
                                <span class="mx-2">/</span>
                                <router-link to="/post-training" class="opacity-50 hover:opacity-100">Post
                                    Internship</router-link>
                                <span class="mx-2">/</span>
                                <span>Post Internship Applications</span>
                            </div>
                            <div class="font-bold">{{ getTitle }}</div>
                        </div>
                    </div>
                </div>

                <!-- <div v-if="role == 'admin' || role == 'superadmin'" class="mt-8 w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <h1 class="text-base md:text-lg font-semibold">Report</h1>
                    <div class="flex items-center flex-wrap">
                        <div class="flex justify-start items-center mr-8">
                            <div>Total Job Applications</div>
                            <div>: {{ !$apollo.queries.postTrainingApplications.loading ? paginatorInfo.total : 0 }}</div>
                        </div>
                        <div class="flex justify-start items-center mr-8">
                            <div>Approved</div>
                            <div>: {{ jobApplicationReport.approved_count }}</div>
                        </div>
                        <div class="flex justify-start items-center mr-8">
                            <div>Rejected</div>
                            <div>: {{ jobApplicationReport.rejected_count }}</div>
                        </div>
                        <div class="flex justify-start items-center mr-8">
                            <div>Not Verified</div>
                            <div>: {{ jobApplicationReport.not_verified_yet_count }}</div>
                        </div>
                    </div>
                </div> -->

                <section class="mt-8 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-between flex-wrap">
                        <h1 class="text-base md:text-lg font-semibold mb-4">{{ getSubTitle }}</h1>
                        <div v-if="role == 'admin' || role == 'superadmin'"
                            class="flex justify-start items-center flex-wrap">
                            <!-- <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Employer:</div>
                                <select v-model="filterByPartner" class="outline-none text-sm w-full sm:w-auto">
                                    <option value="">All Employers</option>
                                    <option :value="item.id" v-for="(item, index) in partnersList" :key="index">{{ item.en_company_name }}</option>
                                </select>
                            </div> -->
                            <!-- <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Status:</div>
                                <select v-model="filterByStatus" class="outline-none text-sm w-full sm:w-auto">
                                    <option value="">All</option>
                                    <option value="1">Approved</option>
                                    <option value="2">Rejected</option>
                                    <option value="3">Pending</option>
                                </select>
                            </div> -->
                        </div>
                    </div>
                    <div class="flex flex-col" v-if="$apollo.queries.postTrainingApplications.loading">
                        <table-shimmer
                            :titleHeaders="['#', 'Student', 'Title', 'Position', 'Position Code', 'Offer Close Date', 'Date Applied', 'Application Status', 'Reason', 'Actions']"
                            :rows="first"></table-shimmer>
                    </div>
                    <div v-else-if="!$apollo.queries.postTrainingApplications.loading && !hasItems"
                        class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No Post Training Applications found!</h1>
                    </div>
                    <div v-else class="flex flex-col">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Student</th>
                                                <th v-if="role == 'admin' || role == 'superadmin'" scope="col"
                                                    class="px-6 py-2 text-gray-400">Employer</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Title</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Description</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Start Date</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">End Date</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Date Applied</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Application Status</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Note</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in items" :key="index"
                                                :class="getClass(item.status)"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">{{
                                                    paginatorInfo.firstItem + index }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div @click.stop="viewStudentProfile(item.user.students.student_id)"
                                                        class="flex items-center cursor-pointer group">
                                                        <div class="flex-shrink-0 mr-3">
                                                            <img class="h-12 w-12 rounded-lg object-cover"
                                                                :src="getProfilePicture(item.user.profile_picture_url, item.user.students.student_id, item.user.students.entity)"
                                                                alt="">
                                                        </div>
                                                        <div class="flex-grow flex flex-col mr-4">
                                                            <h1 class="text-sm font-semibold flex items-center">
                                                                <span class="text-heading group-hover:text-blue-600">{{
                                                                    item.user.name }}</span>
                                                            </h1>
                                                            <p class="text-xs text-gray-400 group-hover:text-blue-400">
                                                                {{ item.user.email }}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td v-if="role == 'admin' || role == 'superadmin'"
                                                    class="whitespace-nowrap px-6 py-2">{{ item.post_training.partner ?
                                                        item.post_training.partner.en_company_name : '' }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.post_training.title }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    item.post_training.description }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    formattedDate(item.post_training.start_date) }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    formattedDate(item.post_training.end_date) }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    formattedDate(item.created_at) }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ getStatus(item.status) }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.note }}</td>
                                                <td class="px-6 py-2">
                                                    <div class="flex">
                                                        <div v-if="hasPermission('post-training-applications-show')"
                                                            @click.stop="viewApplication(item)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-eye
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                                        </div>
                                                        <div v-if="hasPermission('post-training-applications-edit') && isShowApproveReject(item.status)"
                                                            @click.stop="updateApplication(item.token, true)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-approve
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-approve>
                                                        </div>
                                                        <div v-if="hasPermission('post-training-applications-edit') && isShowApproveReject(item.status)"
                                                            @click.stop="rejectClicked(item.token)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-reject
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-reject>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="showAddNote" :title="`Add Your Note`" @close="closeAddNote">
                            <div class="flex flex-col">
                                <label for="note" class="px-8 mt-4 text-sm ml-1">Note</label>
                                <div class="h-32 px-8 rounded-xl mt-2">
                                    <textarea v-model="note"
                                        class="bg-white resize-none w-full h-full outline-none text-sm border p-4 rounded-lg"></textarea>
                                </div>
                                <div class="flex justify-end mt-4 mr-8">
                                    <div @click.stop="addNoteOk"
                                        class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                                        OK</div>
                                </div>
                            </div>
                        </base-modal>
                    </transition>

                </section>
            </div>
        </div>
        <div class="h-full flex justify-center items-center" v-if="isLoading">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>

        <transition name="fade" mode="out-in">
            <base-full-modal v-if="showFullModal" title="Student Profile" @close="closeFullModal">
                <student-profile :student-id="studentId"></student-profile>
            </base-full-modal>
        </transition>

        <transition name="fade" mode="out-in">
            <base-full-modal v-if="isViewPostTrainingApplication"
                :title="`View Post Training Application - ${selectedPostTrainingApplication.user.name}`"
                @close="closeViewPostTrainingApplication">
                <post-training-application-view class="text-left" :item="selectedPostTrainingApplication"
                    :iframe-height="getIframeHeight"></post-training-application-view>
            </base-full-modal>
        </transition>

    </div>
</template>

<script>
import IconApprove from "../../components/icons/IconApprove.vue";
import IconReject from "../../components/icons/IconReject.vue";
import IconBack from "../../components/icons/IconBack.vue";
import IconEye from "../../components/icons/IconEye.vue";
import gql from 'graphql-tag';
import Pagination from "../../components/shared/pagination.vue";
import TableShimmer from '../../components/shared/TableShimmer.vue';
import StudentProfile from "../student-profile/index.vue";
import PostTrainingApplicationView from "./post-training-applications/view.vue";
export default {
    name: "post-training-applications",
    props: ["token"],
    components: {
        IconApprove,
        IconReject,
        IconBack,
        IconEye,
        Pagination,
        TableShimmer,
        StudentProfile,
        PostTrainingApplicationView,
    },
    data() {
        return {
            postTrainingApplications: [],
            first: 10,
            page: 1,
            error: null,
            success: null,
            showAddNote: false,
            note: "",
            selectedToken: null,
            isLoading: false,
            showFullModal: false,
            studentId: null,
            filterByPartner: "",
            partnersList: [],
            filterByStatus: "",
            // jobApplicationReport: [],
            selectedPostTrainingApplication: null,
            selectedJobApplicationId: null,
            isViewPostTrainingApplication: false,
        };
    },
    watch: {
        postTrainingApplications(newVal) {
            if (newVal.error) {
                if (newVal.error_code == 403) {
                    this.$router.replace('/no-permission');
                } else if (newVal.error_code == 401) {
                    this.$router.replace('/');
                } else {
                    alert(newVal.message);
                    this.$router.replace('/');
                }
            }
        },
        filterByPartner() {
            this.page = 1;
            // this.getJobApplicationReport();
        },
        filterByStatus() {
            this.page = 1;
        }
    },
    computed: {
        items() {
            return this.postTrainingApplications.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.postTrainingApplications.paginatorInfo;
        },
        role() {
            return this.$store.getters.role;
        },
        getTitle() {
            if (this.token) {
                if (this.$apollo.queries.postTrainingApplications.loading) {
                    return "";
                } else {
                    if (this.items[0].post_training) {
                        if (this.items[0].post_training.partner) {
                            return `${this.items[0].post_training.partner.en_company_name} - ${this.items[0].post_training.title}`;
                        } else {
                            return `${this.items[0].post_training.title}`;
                        }
                    } else {
                        return "Post Internship Applications";
                    }
                }
            } else {
                return "Post Internship Applications";
            }
        },
        getSubTitle() {
            if (this.token) {
                if (this.$apollo.queries.postTrainingApplications.loading) {
                    return "";
                } else {
                    return `Post Training Applications List (${this.paginatorInfo.total})`
                }
            } else {
                return "Post Training Applications List";
            }
        },
        getIframeHeight() {
            return `${window.innerHeight} px`;
        },
    },
    created() {
        if (this.role == 'admin' || this.role == 'superadmin') {
            this.getPartnersList();
            // this.getJobApplicationReport();
        }
    },
    apollo: {
        postTrainingApplications() {
            return {
                query: gql`query GetAllPostTrainingApplications($first: Int!, $page: Int!, $filter_by_partner: Int, $filter_by_status: Int, $token: String) {
                    postTrainingApplications(first: $first, page: $page, filter_by_partner: $filter_by_partner, filter_by_status: $filter_by_status, token: $token) {
                        error
                        error_code
                        message
                        data {
                            id
                            token
                            user_id
                            post_training_id
                            status
                            note
                            created_at
                            user {
                                name
                                email
                                profile_picture_url
                                students {
                                    student_id
                                    entity
                                }
                            }
                            post_training {
                                id
                                title
                                description
                                start_date
                                end_date
                                partner {
                                    en_company_name
                                }
                            }
                            post_training_application_attachments {
                                url
                            }
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        filter_by_partner: parseInt(this.filterByPartner),
                        filter_by_status: parseInt(this.filterByStatus),
                        token: this.token ? this.token : "",
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        viewStudentProfile(studentId) {
            this.studentId = studentId;
            this.showFullModal = true;
        },
        closeFullModal() {
            this.showFullModal = false;
            this.studentId = null;
        },
        getClass(status) {
            if (status === true) {
                return "bg-green-100";
            } else if (status === false) {
                return "bg-red-100";
            } else {
                return "";
            }
        },
        getProfilePicture(profilePictureUrl, studentId, entity) {
            if (profilePictureUrl == '/storage/alumni-profile-pictures/default-avatar.jpg') {
                return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
            } else {
                return process.env.VUE_APP_PUBLIC_URL + profilePictureUrl;
            }
        },
        getStatus(status) {
            if (status === null) {
                return "Pending";
            } else if (status === false) {
                return "Rejected";
            } else {
                return "Approved";
            }
        },
        isShowApproveReject(status) {
            if (status === null) {
                return true;
            } else {
                return false
            }
        },
        formattedDate(date) {
            if (date) {
                const parsedDate = new Date(date);
                return parsedDate.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).replace(/\//g, '-');
            } else {
                return "";
            }
        },
        setPage(page) {
            this.page = page;
        },
        showToast(message = '') {
            this.$apollo.queries.postTrainingApplications.refetch();
            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            })
            Toast.fire({
                icon: 'success',
                title: message
            })
            this.closeModal();
        },
        rejectClicked(selectedToken) {
            this.selectedToken = selectedToken;
            this.showAddNote = true;
        },
        closeAddNote() {
            this.showAddNote = false;
            this.note = "";
            this.selectedToken = null;
        },
        addNoteOk() {
            this.showAddNote = false;
            this.updateApplication(this.selectedToken, false);
        },
        async updateApplication(token, status) {

            this.isLoading = true;

            const UPDATE_MUTATION = gql`
                mutation UpdatePostTrainingApplication($token: String!, $status: Boolean!, $note: String) {
                    updatePostTrainingApplication(token: $token, status: $status, note: $note) {
                        error
                        message
                    }
                }
            `;

            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_MUTATION,
                    variables: {
                        token: token,
                        status: status,
                        note: this.note,
                    }
                }).then((data) => {
                    if (data.data.updatePostTrainingApplication.error) {
                        this.error = data.data.updatePostTrainingApplication.message;
                    } else {
                        this.success = data.data.updatePostTrainingApplication.message;
                    }
                }).catch((error) => {
                    console.error(error)
                })
            } catch (error) {
                this.error = error.message || "Failed to authenticate, try later.";
            }

            if (this.error === null) {

                this.isLoading = false;

                this.note = "";

                this.$apollo.queries.postTrainingApplications.refetch();

                const Toast = this.$swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', this.$swal.stopTimer)
                        toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                    }
                })

                if (status) {
                    Toast.fire({
                        icon: 'success',
                        title: this.success
                    })
                } else {
                    Toast.fire({
                        icon: 'success',
                        title: this.success
                    })
                }
            } else {

                this.isLoading = false;

                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: this.error,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        this.error = null;
                    }
                })
            }

        },
        hasPermission(crudName) {
            if (this.role == 'superadmin') {
                return true;
            } else {
                const permissions = this.$store.getters.permissions;
                const permissionsArray = permissions.split(",");
                if (permissionsArray.includes(crudName)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        async getPartnersList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query GetActivePartnersList {
                            activePartners {
                                data {
                                    id
                                    en_company_name
                                }
                            }
                        }
                    `,
                    fetchPolicy: 'network-only',
                });
                this.partnersList = data.activePartners.data;
            } catch (error) {
                console.log(error);
            }
        },
        viewApplication(selectedPostTrainingApplication) {
            this.selectedPostTrainingApplication = selectedPostTrainingApplication;
            this.isViewPostTrainingApplication = true;
        },
        closeViewPostTrainingApplication() {
            this.isViewPostTrainingApplication = false;
            this.selectedPostTrainingApplication = null;
        },
        async getJobApplicationReport() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query GetJobApplicationReport($filter_by_partner: Int) {
                            jobApplicationReport(filter_by_partner: $filter_by_partner) {
                                data {
                                    not_verified_yet_count
                                    approved_count
                                    rejected_count
                                }
                            }
                        }
                    `,
                    variables: {
                        filter_by_partner: parseInt(this.filterByPartner),
                    },
                    fetchPolicy: 'network-only',
                });
                this.jobApplicationReport = data.jobApplicationReport.data;
            } catch (error) {
                console.log(error);
            }
        },
        goBackTo(url) {
            this.$router.replace(url);
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

@responsive {
    .min-ht-78 {
        min-height: 78px;
    }
}
</style>